<template>
<div :style="styles" :class="cssClasses">
  <canvas :id="chartId" ref="canvas" :width="width" :height="height"></canvas>
</div>
</template>

<script lang="js">
import Chart from 'chart.js'

Chart.defaults.scale.gridLines.color = '#c0d5ef'
Chart.defaults.scale.gridLines.zeroLineColor = '#c0d5ef'
Chart.defaults.bar.scales.xAxes[0].maxBarThickness = 16

export default {
  name: 'ChartCmp',
  components: {},
  props: {
    chartType: String,
    chartId: String,
    width: {type: Number, default: 400},
    height: {type: Number, default: 400},
    cssClasses: '',
    styles: '',
    plugins: Array
  },
  data () {
    return {
      nativeChart: null,
      nativePlugins: this.plugins
    }
  },
  beforeDestroy () {
    if (this.nativeChart) {
      this.nativeChart.destroy()
      this.nativeChart = null
    }
  },
  destroyed () {
    if (this.nativeChart) {
      this.nativeChart.destroy()
      this.nativeChart = null
    }
  },
  methods: {
    addPlugin (plugin) {
      this.nativePlugins.push(plugin)
    },
    generateLegend () {
      if (this.nativeChart) {
        return this.nativeChart.generateLegend()
      }
    },
    renderChart (data, options) {
      if (this.nativeChart) this.nativeChart.destroy()
      const canvas = (this.$refs.canvas).getContext('2d')

      this.nativeChart = new Chart(canvas, {
        type: this.chartType,
        data: data,
        options: options,
        plugins: this.nativePlugins
      })
    },
    getDatasetMeta (index) {
      return this.nativeChart.getDatasetMeta(index)
    },
    update () {
      return this.nativeChart.update()
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/chart/base.vue